import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { ProgressSpinnerMode, MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DynamicConfirmationComponent } from '../dynamic-confirmation/dynamic-confirmation.component';

@Component({
  selector: 'app-loading-spinner-overlay',
  imports: [MatProgressSpinnerModule, DynamicConfirmationComponent],
  templateUrl: './loading-spinner-overlay.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './loading-spinner-overlay.component.scss',
})
export class LoadingSpinnerOverlayComponent {
  @Input() isLoading: boolean = false;
  @Input() spinnerSize: number = 100;
  @Input() screenReaderText: string | undefined;
}
